import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { useLocation } from "react-router-dom";

import "./styles.sass";

// Constants
import { GET_POPUP_TYPES } from "../../../constants/popupConfig";

const NavTrigger = () => {
  const location = useLocation();
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    if (isClosed) {
      setTimeout(() => {
        setIsClosed(false);
      }, 1000);
    }
  }, [isClosed]);

  const navTriggerClass = classNames("navTrigger", {
    // eslint-disable-next-line camelcase
    navTrigger_active: location.search.includes(GET_POPUP_TYPES.popup.sideMenu),
    // eslint-disable-next-line camelcase
    navTrigger_close: isClosed,
  });

  const handleClick = () => {
    if (location.search.includes(GET_POPUP_TYPES.popup.sideMenu)) {
      setIsClosed(true);
    }
  };

  return (
    <div className={navTriggerClass} onClick={handleClick}>
      <i />
      <i />
      <i />
    </div>
  );
};

export default NavTrigger;
